<script setup lang="ts">
defineProps<{
  variant: SingleProductVariant
}>()
</script>

<template>
  <ul class="details-list" :class="{ wrap: variant.isPurchasable }">
    <li v-if="!variant.isPurchasable && variant.authors?.trim()">
      <b>Forfatter{{ variant.authors?.includes(",") ? "e" : "" }}: </b>
      <span v-text="variant.authors" />
    </li>
    <li v-if="variant.languages?.length">
      <b>Språk: </b>
      <span v-text="languages(variant)" />
    </li>
    <li v-if="variant.grades?.length">
      <b>Trinn: </b>
      <span
        class="capitalize"
        v-text="
          variant.grades.map((it) => it.replace('aarstrinn', '')).join(', ')
        "
      />
    </li>
    <li v-if="variant.release && !variant.formats?.includes('nettsted')">
      <b>Utgitt: </b>
      <span v-text="formatNorwegianDate(variant.release)" />
    </li>
    <li>
      <b>ISBN: </b>
      <span v-text="variant.isbn" />
    </li>
  </ul>
</template>

<style scoped>
@reference "~/assets/styles/main.css";

.details-list {
  font-size: 0.875rem;
  line-height: 150%;
  display: flex;
  flex-direction: column;

  &.wrap {
    @media screen and (min-width: theme('screens.sm')) {
      flex-flow: column wrap;
      max-height: 3rem;
    }
  }

  b {
    font-weight: 600;
  }
}
</style>
